import { render, staticRenderFns } from "./MenuManage.vue?vue&type=template&id=cd528eda&scoped=true"
import script from "./MenuManage.vue?vue&type=script&lang=js"
export * from "./MenuManage.vue?vue&type=script&lang=js"
import style0 from "./MenuManage.vue?vue&type=style&index=0&id=cd528eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd528eda",
  null
  
)

export default component.exports